// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-location-access-form .invalid-feedback{display:none}.was-validated .user-location-access-form{border-color:#dc3545}.was-validated .user-location-access-form .invalid-feedback{display:block;margin-bottom:1em}", ""]);
// Exports
module.exports = exports;
